angular.module("ainapp")
    .controller("profileController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Profile";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Currencys = [];
            MainService.CurrencyInDropdown().then(function (response) {
                $scope.Currencys = response.data;
            })

            $scope.Vats = [];
            MainService.VATsInDropdown().then(function (response) {
                $scope.Vats = response.data;
            })

            $scope.AccTypes = [];
            MainService.AccountTypesInDropdown().then(function (response) {
                $scope.AccTypes = response.data;
            });

            $scope.FinYears = [];
            MainService.FinYearInDropDown().then(function (response) {
                $scope.FinYears = response.data;
            });

            $scope.Units = [];
            MainService.UnitsInDropdown().then(function (response) {
                $scope.Units = response.data;
            });

            $scope.Costcenters = [];
            MainService.CostCenterList().then(function (response) {
                $scope.Costcenters = response.data;
            });

            $scope.Warehouses = [];
            MainService.WarehousesInDropdown().then(function (response) {
                $scope.Warehouses = response.data;
            });

            $scope.StateCostCenters = [];
            MainService.GetStateCostCenters().then(function (response) {
                $scope.StateCostCenters = response.data;
            });


            $scope.Init = function () {

                $scope.load = false;
                $scope.CompanyProfile = {};
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetCompanyProfile().then(function (response) {
                    $scope.CompanyProfile = response.data;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })


                $scope.ViewVal = 0;

            }
            $scope.Init();

            $scope.handleFileSelect = function (evt) {
                var file = evt.currentTarget.files[0];
                var reader = new FileReader();
                reader.onload = function (evt) {
                    $scope.$apply(function ($scope) {
                        $scope.myImage2 = evt.target.result;
                        $scope.CompanyProfile.Logo = evt.target.result;
                    });
                };
                reader.readAsDataURL(file);
            };


            $scope.AccountAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        console.log(o.data);
                        MainService.accountInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        });

                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.AccountGroupsAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        MainService.accountGroupsInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.DefaultCusAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: $scope.SearchByNameLan,
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile.DefaultCustomer = {};
                    $scope.CompanyProfile.DefaultCustomer.Name = data.Name;
                    $scope.CompanyProfile.DefaultCustomerId = data.Id;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.DefaultCustomerHeadAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: $scope.SearchByNameLan,
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile.DefaultCustomerHead = {};
                    $scope.CompanyProfile.DefaultCustomerHead.Name = data.Name;
                    $scope.CompanyProfile.DefaultCustomerHeadId = data.Id;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.AccountGroupsAutocompleteDataSource
            };

            $scope.DefaultVendorHeadAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: $scope.SearchByNameLan,
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile.DefaultVendorHead = {};
                    $scope.CompanyProfile.DefaultVendorHead.Name = data.Name;
                    $scope.CompanyProfile.DefaultVendorHeadId = data.Id;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.AccountGroupsAutocompleteDataSource
            };

            $scope.DefaultExpenseHeadAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: $scope.SearchByNameLan,
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile.DefaultExpenseHead = {};
                    $scope.CompanyProfile.DefaultExpenseHead.Name = data.Name;
                    $scope.CompanyProfile.DefaultExpenseHeadId = data.Id;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.AccountGroupsAutocompleteDataSource
            };

            $scope.DefaultEmployeeHeadAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: $scope.SearchByNameLan,
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile.DefaultEmployeeHead = {};
                    $scope.CompanyProfile.DefaultEmployeeHead.Name = data.Name;
                    $scope.CompanyProfile.DefaultEmployeeHeadId = data.Id;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.AccountGroupsAutocompleteDataSource
            };



            $scope.SaveData = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                $scope.load = true;
                MainService.SaveCompanyProfile($scope.CompanyProfile).then(function (response) {
                    $scope.load = false;
                    if (response) {
                        toastr.success("Success");
                        $scope.Init();
                        $scope.InitMain();
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }



      }]);
